import { Modal, Paper, IconButton } from '@mui/material';
import { CancelIcon } from '../../Icons';


function CUModal({ open, handleClose, component, width = { xs: '100%', sm: 480, md: 640, lg: 760 }, ...props }) {
    const closeButton = { cursor: 'pointer', float: 'right' };

    return (
        <Modal
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}
            open={open}
            onClose={handleClose}
            disableEscapeKeyDown={false}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description">
            <Paper sx={{ width, maxWidth: '100%', maxHeight: '90dvh', overflowY: 'auto' }}>
                <IconButton style={closeButton} size="small" onClick={handleClose}><CancelIcon /></IconButton>
                {component({ onFinish: handleClose, ...props })}
            </Paper>
        </Modal>)
}

export default CUModal;